module.exports = __webpack_public_path__ + "static/values_4-aaa69f20c6e9a894e7d65b71f26d4730.svg";